import axios from 'axios';
import { getToken } from '@src/public/utils/app';
import { TL_API_URL, STAR_BASE_PATH, COMMENT_APP_ID } from '@src/public/constants';

// 获取用户token
const token = getToken();

// 时间线实例
export const timelineAxios = axios.create();
// 时间线实例的基础路径
timelineAxios.defaults.baseURL = TL_API_URL;
// 时间线实例的自定义header
const timelineHeaders = {
    Authorization: `Bearer ${token}`,
};

timelineAxios.interceptors.request.use(
    config => {
        return { ...config, headers: { ...config.headers, ...timelineHeaders } };
    },
    err => {
        return Promise.reject(err);
    },
);

timelineAxios.interceptors.response.use(
    response => {
        const { status } = response;

        if (status === 200) {
            return response.data;
        }

        return response;
    },
    err => {
        const { response } = err;

        return Promise.reject(response);
    },
);

// 点赞评论实例
export const likeCommentAxios = axios.create();

// 时间线实例的基础路径
likeCommentAxios.defaults.baseURL = STAR_BASE_PATH;

// 时间线实例的自定义header
const likeCommentHeaders = {
    Authorization: `Bearer ${token}`,
    appId: COMMENT_APP_ID,
    commentAppId: COMMENT_APP_ID,
};

likeCommentAxios.interceptors.request.use(
    config => {
        return {
            ...config,
            headers: { ...config.headers, ...likeCommentHeaders },
        };
    },
    err => {
        return Promise.reject(err);
    },
);

likeCommentAxios.interceptors.response.use(
    response => {
        const { status } = response;

        if (status === 200) {
            return response.data;
        }

        return response;
    },
    err => {
        return Promise.resolve(err);
    },
);

export default timelineAxios;
